<template>
  <div class="w-full p-4 mt-4">
    <div class="w-full text-center font-bold mb-3 text-sm">
      <span class="capitalize ...">{{ config.WidgetTitle }}</span>
      <span v-if="$route.query.preview === 1"
        >(every {{ config.RefreshRate }} s)</span
      >
    </div>
    <div class="grid grid-cols-3 gap-4">
      <template v-for="(item, index) in config.CurrentValues">
        <div
          :key="index"
          class="col-span-3 text-center font-bold mb-3 text-sm"
          v-if="config.CurrentValues.length === 1"
        >
          <i class="el-icon-s-platform"></i> {{ item.deviceName }}

          <div
            class="text-center rounded-full h-32 flex items-center justify-center..."
            style="margin: auto"
          >
            <h1 class="w-full">{{ item.DecimalVal }} {{ item.Unit }}</h1>
          </div>
          <h6 class="w-full text-center">
            <strong>last update:</strong>
            {{ formattedDateTime(item.Timestamp) }}
          </h6>
        </div>
        <div
          class="col-auto text-center font-bold mb-3 text-sm"
          v-else
          :key="index"
        >
          <i class="el-icon-s-platform"></i> {{ item.deviceName }}

          <div
            class="text-center rounded-full h-32 flex items-center justify-center..."
            style="margin: auto"
          >
            <h2 class="w-full">{{ item.DecimalVal }} {{ item.Unit }}</h2>
          </div>
          <h6 class="w-full text-center">
            <strong>last update:</strong>
            {{ formattedDateTime(item.Timestamp) }}
          </h6>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { format, date, utc } from '@/helpers/datetime'

export default {
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    formattedDateTime(stringDate) {
      return format(stringDate, 'D MMM YYYY h:mm:ss A')
    }
  },
  watch: {}
}
</script>
